module.exports = __webpack_public_path__ + "static/media/DownArrow.9524e787.svg";